var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilver1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 645,
    height: 635,
    viewBox: "0 0 645 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 291.8V158.1C0.600098 141.7 9.3001 126.6 23.5001 118.5L139.3 51.7L278 131.8V291.9L139.3 372L0.600098 291.8Z",
    fill: "#B5A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M644 291.8V158.1C644 141.7 635.3 126.6 621.1 118.5L505.3 51.7L366.6 131.8V291.9L505.3 372L644 291.8Z",
    fill: "#676077"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M505.4 51.7L613.7 114.2L634.2 137.4L366.7 291.8V131.7L505.4 51.7Z",
    fill: "#B5A5B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M505.4 63.2L616.2 127.2C627.2 133.6 634.1 145.4 634.1 158.2V286L505.4 360.3L376.7 286V137.5L505.4 63.2ZM505.4 51.7L366.7 131.8V291.9L505.4 372L644.1 291.9V158.1C644.1 141.7 635.4 126.6 621.2 118.5L505.4 51.7Z",
    fill: "#B5A5B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2 51.7L36.8 110.8L28.6 115.5L10.3 137.3L277.9 291.8V131.7L139.2 51.7Z",
    fill: "#FEF6FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2 63.2L267.9 137.5V286L139.2 360.3L10.6001 286V158.1C10.6001 145.4 17.5001 133.5 28.5001 127.1L139.2 63.2ZM139.2 51.7L23.5001 118.5C9.3001 126.7 0.600098 141.8 0.600098 158.1V291.8L139.3 371.9L278 291.8V131.7L139.2 51.7Z",
    fill: "#B5A5B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 476V159L322.3 0.5L596.8 159V476L322.3 634.4L47.8 476Z",
    fill: "#B5A5B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 634.4L596.8 476L547.8 447.7L342.3 566.4C329.9 573.5 322.3 586.7 322.3 601V634.4Z",
    fill: "#676077"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 476L322.3 634.5V601C322.3 586.7 314.7 573.5 302.3 566.4L116.7 459.3C104.3 452.2 89.1 452.2 76.8 459.3L47.8 476Z",
    fill: "#A88696"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 34V4L52 161.4L76.8 175.7C89.2 182.8 104.4 182.8 116.7 175.7L302.3 68.6C314.7 61.5 322.3 48.3 322.3 34Z",
    fill: "#FEF6FA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M593.7 474.1L592.7 161.4L567.9 175.7C555.5 182.8 547.9 196 547.9 210.3V447.6L593.7 474.1Z",
    fill: "#676077"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M499.1 197.6L371.5 123.9C356.6 115.3 339.6 110.7 322.4 110.7C305.2 110.7 288.2 115.3 273.3 123.9L145.7 197.6C135.7 203.4 129.5 214.1 129.5 225.6V297.1C129.5 322.7 140 347.2 158.3 364.9V370.1C158.3 406.6 177.9 440.6 209.4 458.8L322.4 524.1L435.4 458.8C467.8 440.1 485.9 406.8 486.5 364.9C504.9 347.1 515.3 322.7 515.3 297.1V225.6C515.3 214.1 509.1 203.4 499.1 197.6Z",
    fill: "#1C1128"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 323.5L167.3 236.3V297.2C167.3 317.3 178 335.9 195.4 345.9L322.2 419.1L449 345.9C466.4 335.8 477.1 317.3 477.1 297.2V236.3L322.3 323.5Z",
    fill: "#342A44"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 419.1L196.2 346.3V370.2C196.2 393.3 208.4 414.5 228.3 426L322.3 480.3L416.3 426C436.2 414.5 448.4 393.3 448.4 363V346.3L322.3 419.1Z",
    fill: "#342A44"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M467.3 253.4V297.2C467.3 313.7 458.4 329 444.2 337.3L443.5 337.7L438.5 340.6V346.4V363.1C438.5 388.4 429.1 407.2 411.4 417.4L322.4 468.8L233.4 417.4C216.7 407.8 206.3 389.7 206.3 370.3V346.4V340.6L201.3 337.7L200.6 337.3C186.3 329.1 177.5 313.7 177.5 297.2V253.4L317.6 332.2L322.5 335L327.4 332.2L467.3 253.4ZM477.3 236.3L322.3 323.5L167.3 236.3V297.2C167.3 317.3 178 335.9 195.4 345.9L196.1 346.3V370.2C196.1 393.3 208.3 414.5 228.2 426L322.2 480.3L416.2 426C436.1 414.5 448.3 393.3 448.3 363V346.3L449 345.9C466.4 335.8 477.1 317.3 477.1 297.2V236.3H477.3Z",
    fill: "#443B59"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.8 215.4L322.3 291.3L453.8 215.4L352.4 156.9C333.7 146.1 310.8 146.1 292.1 156.9L190.8 215.4Z",
    fill: "#698445"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M352.5 156.9C343.2 151.5 332.8 148.8 322.4 148.8V291.4L453.9 215.5L352.5 156.9Z",
    fill: "#1F4927"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 236.3L196.1 218.5L322.3 291.3L448.5 218.5L322.3 236.3Z",
    fill: "#143321"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 158.8C331.1 158.8 339.8 161.1 347.4 165.5L433.8 215.4L322.3 279.8L210.8 215.4L297.2 165.5C304.8 161.1 313.5 158.8 322.3 158.8ZM322.3 148.8C311.9 148.8 301.5 151.5 292.2 156.9L190.8 215.4L322.3 291.3L453.8 215.4L352.4 156.9C343.1 151.5 332.7 148.8 322.3 148.8Z",
    fill: "#2B5E36"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 12L586.8 164.7V470.1L322.3 622.8L57.8 470.1V164.7L322.3 12ZM322.3 0.5L47.8 159V476L322.3 634.5L596.8 476V159L322.3 0.5Z",
    fill: "#B5A5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver1);
export default __webpack_public_path__ + "static/media/silver-1.b694a8fcee43995f9d8eacdb1cdd283b.svg";
export { ForwardRef as ReactComponent };